export default [
    {
        date: 1585130622813,
        row: 18,
        col: 18,
        squares: [
            [1, 13, "#000000"],
            [2, 14, "#000000"],
            [3, 14, "#000000"],
            [2, 12, "#000000"],
            [3, 12, "#000000"],
            [4, 14, "#000000"],
            [4, 12, "#000000"],
            [5, 11, "#000000"],
            [4, 10, "#000000"],
            [4, 9, "#000000"],
            [4, 8, "#000000"],
            [4, 7, "#000000"],
            [5, 6, "#000000"],
            [4, 5, "#000000"],
            [3, 5, "#000000"],
            [2, 5, "#000000"],
            [1, 4, "#000000"],
            [2, 3, "#000000"],
            [3, 3, "#000000"],
            [4, 3, "#000000"],
            [5, 3, "#000000"],
            [6, 4, "#000000"],
            [5, 14, "#000000"],
            [6, 13, "#000000"],
            [7, 12, "#000000"],
            [9, 12, "#000000"],
            [10, 11, "#000000"],
            [8, 12, "#000000"],
            [7, 5, "#000000"],
            [8, 5, "#000000"],
            [9, 5, "#000000"],
            [10, 6, "#000000"],
            [10, 7, "#000000"],
            [10, 10, "#000000"],
            [11, 9, "#000000"],
            [11, 8, "#000000"],
            [7, 10, "#000000"],
            [7, 7, "#000000"],
            [9, 6, "#980000"],
            [9, 11, "#980000"],
            [2, 4, "#000000"],
            [2, 13, "#000000"],
            [11, 5, "#000000"],
            [12, 5, "#000000"],
            [12, 4, "#000000"],
            [13, 4, "#000000"],
            [14, 4, "#000000"],
            [15, 4, "#000000"],
            [11, 12, "#000000"],
            [15, 13, "#000000"],
            [17, 12, "#000000"],
            [18, 7, "#000000"],
            [18, 5, "#000000"],
            [17, 5, "#000000"],
            [16, 5, "#000000"],
            [18, 8, "#000000"],
            [18, 10, "#000000"],
            [18, 11, "#000000"],
            [18, 12, "#000000"],
            [18, 9, "#000000"],
            [18, 6, "#000000"],
            [14, 13, "#000000"],
            [13, 14, "#000000"],
            [11, 14, "#000000"],
            [10, 14, "#000000"],
            [9, 14, "#000000"],
            [9, 15, "#000000"],
            [8, 16, "#000000"],
            [7, 16, "#000000"],
            [7, 18, "#000000"],
            [7, 17, "#000000"],
            [8, 18, "#000000"],
            [9, 18, "#000000"],
            [10, 18, "#000000"],
            [10, 17, "#000000"],
            [11, 17, "#000000"],
            [12, 16, "#000000"],
            [13, 16, "#000000"],
            [12, 14, "#000000"],
            [14, 16, "#000000"],
            [15, 15, "#000000"],
            [15, 14, "#000000"],
            [15, 6, "#000000"],
            [12, 13, "#000000"],
            [13, 13, "#000000"],
            [16, 12, "#000000"],
            [15, 11, "#000000"],
            [8, 17, "#000000"],
            [9, 17, "#000000"],
            [9, 16, "#000000"],
            [10, 16, "#FFFF00"],
            [11, 16, "#FFFF00"],
            [10, 15, "#FFFF00"],
            [12, 15, "#FFFF00"],
            [13, 15, "#FFFF00"],
            [14, 15, "#FFFF00"],
            [14, 14, "#FFFF00"],
            [11, 15, "#FFFF00"],
            [14, 9, "#FFFF00"],
            [12, 7, "#FFFF00"],
            [11, 6, "#FFFF00"],
            [11, 7, "#FFFF00"],
            [3, 13, "#FFFF00"],
            [4, 13, "#FFFF00"],
            [5, 13, "#FFFF00"],
            [5, 12, "#FFFF00"],
            [6, 12, "#FFFF00"],
            [6, 11, "#FFFF00"],
            [6, 10, "#FFFF00"],
            [5, 10, "#FFFF00"],
            [5, 8, "#FFFF00"],
            [6, 9, "#FFFF00"],
            [5, 9, "#FFFF00"],
            [5, 7, "#FFFF00"],
            [6, 7, "#FFFF00"],
            [6, 8, "#FFFF00"],
            [6, 6, "#FFFF00"],
            [6, 5, "#FFFF00"],
            [5, 5, "#FFFF00"],
            [5, 4, "#FFFF00"],
            [3, 4, "#FFFF00"],
            [4, 4, "#FFFF00"],
            [7, 11, "#FFFF00"],
            [8, 11, "#FFFF00"],
            [8, 10, "#FFFF00"],
            [9, 10, "#FFFF00"],
            [9, 9, "#FFFF00"],
            [10, 9, "#FFFF00"],
            [9, 8, "#FFFF00"],
            [10, 8, "#FFFF00"],
            [9, 7, "#FFFF00"],
            [8, 7, "#FFFF00"],
            [7, 6, "#FFFF00"],
            [8, 6, "#FFFF00"],
            [7, 8, "#FFFF00"],
            [8, 8, "#FFFF00"],
            [7, 9, "#FFFF00"],
            [8, 9, "#FFFF00"],
            [11, 10, "#FFFF00"],
            [11, 11, "#FFFF00"],
            [12, 11, "#FFFF00"],
            [13, 12, "#FFFF00"],
            [14, 12, "#FFFF00"],
            [16, 11, "#FFFF00"],
            [16, 10, "#FFFF00"],
            [16, 9, "#FFFF00"],
            [16, 8, "#FFFF00"],
            [16, 7, "#FFFF00"],
            [16, 6, "#FFFF00"],
            [17, 6, "#FFFF00"],
            [17, 8, "#FFFF00"],
            [17, 10, "#FFFF00"],
            [17, 11, "#FFFF00"],
            [17, 9, "#FFFF00"],
            [17, 7, "#FFFF00"],
            [15, 7, "#FFFF00"],
            [14, 7, "#FFFF00"],
            [14, 6, "#FFFF00"],
            [15, 5, "#FFFF00"],
            [13, 5, "#FFFF00"],
            [14, 5, "#FFFF00"],
            [13, 6, "#FFFF00"],
            [12, 6, "#FFFF00"],
            [13, 7, "#FFFF00"],
            [13, 10, "#FFFF00"],
            [13, 11, "#FFFF00"],
            [12, 12, "#FFFF00"],
            [15, 12, "#FFFF00"],
            [14, 11, "#FFFF00"],
            [14, 10, "#FFFF00"],
            [15, 10, "#FFFF00"],
            [15, 9, "#FFFF00"],
            [15, 8, "#FFFF00"],
            [14, 8, "#FFFF00"],
            [12, 8, "#FFFF00"],
            [12, 10, "#FFFF00"],
            [13, 9, "#FFFF00"],
            [13, 8, "#FFFF00"],
            [12, 9, "#FFFF00"],
        ],
    },
    {
        date: 1585763196404,
        row: 18,
        col: 18,
        squares: [
            [1, 18, "#D9D9D9"],
            [1, 17, "#D9D9D9"],
            [1, 16, "#D9D9D9"],
            [1, 15, "#D9D9D9"],
            [1, 13, "#D9D9D9"],
            [1, 12, "#D9D9D9"],
            [1, 14, "#D9D9D9"],
            [1, 10, "#D9D9D9"],
            [1, 11, "#D9D9D9"],
            [18, 1, "#A61C00"],
            [18, 2, "#A61C00"],
            [18, 3, "#A61C00"],
            [18, 4, "#A61C00"],
            [18, 5, "#A61C00"],
            [18, 7, "#A61C00"],
            [18, 8, "#A61C00"],
            [18, 6, "#A61C00"],
            [18, 9, "#A61C00"],
            [18, 10, "#A61C00"],
            [18, 11, "#A61C00"],
            [18, 12, "#A61C00"],
            [18, 13, "#A61C00"],
            [18, 14, "#A61C00"],
            [18, 15, "#A61C00"],
            [18, 17, "#A61C00"],
            [18, 16, "#A61C00"],
            [18, 18, "#A61C00"],
            [17, 17, "#A61C00"],
            [17, 16, "#A61C00"],
            [17, 14, "#A61C00"],
            [17, 13, "#A61C00"],
            [17, 15, "#A61C00"],
            [17, 11, "#A61C00"],
            [17, 12, "#A61C00"],
            [17, 10, "#A61C00"],
            [17, 9, "#A61C00"],
            [17, 8, "#A61C00"],
            [17, 7, "#A61C00"],
            [17, 5, "#A61C00"],
            [17, 6, "#A61C00"],
            [17, 4, "#A61C00"],
            [17, 3, "#A61C00"],
            [17, 2, "#A61C00"],
            [16, 3, "#A61C00"],
            [16, 4, "#A61C00"],
            [16, 5, "#A61C00"],
            [16, 6, "#A61C00"],
            [16, 7, "#A61C00"],
            [16, 8, "#A61C00"],
            [16, 9, "#A61C00"],
            [16, 11, "#A61C00"],
            [16, 12, "#A61C00"],
            [16, 10, "#A61C00"],
            [15, 12, "#A61C00"],
            [16, 14, "#A61C00"],
            [16, 13, "#A61C00"],
            [16, 15, "#A61C00"],
            [15, 13, "#A61C00"],
            [15, 14, "#A61C00"],
            [15, 11, "#A61C00"],
            [15, 10, "#A61C00"],
            [15, 9, "#A61C00"],
            [15, 8, "#A61C00"],
            [15, 7, "#A61C00"],
            [15, 5, "#A61C00"],
            [15, 6, "#A61C00"],
            [15, 4, "#A61C00"],
            [14, 6, "#A61C00"],
            [14, 5, "#A61C00"],
            [14, 7, "#A61C00"],
            [14, 11, "#A61C00"],
            [14, 8, "#A61C00"],
            [14, 10, "#A61C00"],
            [14, 9, "#A61C00"],
            [14, 12, "#A61C00"],
            [14, 13, "#A61C00"],
            [13, 6, "#A61C00"],
            [13, 7, "#A61C00"],
            [13, 9, "#A61C00"],
            [12, 9, "#A61C00"],
            [13, 8, "#A61C00"],
            [13, 11, "#A61C00"],
            [13, 10, "#A61C00"],
            [13, 12, "#A61C00"],
            [12, 11, "#A61C00"],
            [12, 10, "#A61C00"],
            [12, 8, "#A61C00"],
            [12, 7, "#A61C00"],
            [11, 6, "#A61C00"],
            [11, 7, "#A61C00"],
            [11, 9, "#A61C00"],
            [11, 8, "#A61C00"],
            [11, 10, "#A61C00"],
            [11, 11, "#A61C00"],
            [11, 12, "#A61C00"],
            [10, 7, "#FF0000"],
            [9, 7, "#FF0000"],
            [8, 7, "#FF0000"],
            [9, 6, "#FF0000"],
            [8, 6, "#FF9900"],
            [6, 5, "#FF0000"],
            [7, 7, "#FF0000"],
            [6, 8, "#FF9900"],
            [10, 9, "#FF0000"],
            [9, 9, "#FF0000"],
            [8, 10, "#FF0000"],
            [7, 10, "#FF0000"],
            [4, 10, "#FF0000"],
            [6, 10, "#FF0000"],
            [6, 11, "#FF0000"],
            [8, 9, "#FF9900"],
            [8, 13, "#FF0000"],
            [7, 16, "#FF0000"],
            [5, 18, "#D9D9D9"],
            [10, 17, "#FF0000"],
            [9, 4, "#FF9900"],
            [10, 13, "#FF9900"],
            [9, 10, "#FF0000"],
            [9, 11, "#FF9900"],
            [8, 12, "#FF0000"],
            [8, 15, "#FF0000"],
            [5, 15, "#FF0000"],
            [5, 13, "#FF0000"],
            [5, 9, "#FF0000"],
            [5, 7, "#FF0000"],
            [4, 4, "#FF0000"],
            [5, 5, "#FF0000"],
            [7, 2, "#FF0000"],
            [7, 4, "#FF0000"],
            [7, 3, "#FF0000"],
            [9, 3, "#FF0000"],
            [8, 3, "#FF0000"],
            [7, 14, "#FF9900"],
            [6, 14, "#FF0000"],
            [6, 15, "#FF9900"],
            [9, 8, "#FF9900"],
            [10, 8, "#FF9900"],
            [8, 8, "#FF9900"],
            [6, 9, "#FF9900"],
            [7, 8, "#FF9900"],
            [7, 9, "#FF9900"],
            [7, 12, "#FF9900"],
            [7, 11, "#FF9900"],
            [7, 13, "#FF9900"],
            [6, 13, "#FF9900"],
            [5, 11, "#FF9900"],
            [5, 12, "#FF9900"],
            [6, 12, "#FF9900"],
            [6, 16, "#FF9900"],
            [8, 17, "#FF9900"],
            [8, 11, "#FF9900"],
            [4, 13, "#FF9900"],
            [9, 5, "#FF9900"],
            [8, 5, "#FF9900"],
            [4, 3, "#FF9900"],
            [5, 10, "#FF0000"],
            [4, 7, "#FF0000"],
            [4, 8, "#FF0000"],
            [7, 6, "#FF0000"],
            [5, 3, "#FF0000"],
            [5, 8, "#FF0000"],
            [6, 6, "#FF0000"],
            [4, 6, "#FF9900"],
            [4, 5, "#FF9900"],
            [7, 15, "#FF9900"],
            [12, 13, "#FF9900"],
            [9, 13, "#FF9900"],
            [8, 14, "#FF9900"],
            [8, 16, "#FF9900"],
            [9, 16, "#FF9900"],
            [1, 9, "#D9D9D9"],
            [2, 18, "#D9D9D9"],
            [3, 18, "#D9D9D9"],
            [4, 18, "#D9D9D9"],
            [2, 17, "#D9D9D9"],
            [3, 17, "#D9D9D9"],
            [4, 17, "#D9D9D9"],
            [6, 17, "#D9D9D9"],
            [5, 17, "#D9D9D9"],
            [7, 17, "#D9D9D9"],
            [6, 18, "#D9D9D9"],
            [7, 18, "#D9D9D9"],
            [8, 18, "#D9D9D9"],
            [9, 18, "#D9D9D9"],
            [10, 18, "#D9D9D9"],
            [11, 18, "#D9D9D9"],
            [12, 18, "#D9D9D9"],
            [13, 18, "#D9D9D9"],
            [15, 17, "#D9D9D9"],
            [14, 18, "#D9D9D9"],
            [15, 18, "#D9D9D9"],
            [16, 18, "#D9D9D9"],
            [17, 18, "#D9D9D9"],
            [9, 17, "#D9D9D9"],
            [11, 17, "#D9D9D9"],
            [13, 17, "#D9D9D9"],
            [12, 17, "#D9D9D9"],
            [14, 17, "#D9D9D9"],
            [16, 17, "#D9D9D9"],
            [16, 16, "#D9D9D9"],
            [15, 16, "#D9D9D9"],
            [14, 16, "#D9D9D9"],
            [13, 16, "#D9D9D9"],
            [12, 16, "#D9D9D9"],
            [10, 16, "#D9D9D9"],
            [11, 16, "#D9D9D9"],
            [9, 15, "#D9D9D9"],
            [10, 15, "#D9D9D9"],
            [11, 15, "#D9D9D9"],
            [12, 15, "#D9D9D9"],
            [14, 15, "#D9D9D9"],
            [13, 15, "#D9D9D9"],
            [15, 15, "#D9D9D9"],
            [14, 14, "#D9D9D9"],
            [13, 14, "#D9D9D9"],
            [12, 14, "#D9D9D9"],
            [9, 14, "#D9D9D9"],
            [9, 12, "#FF0000"],
            [10, 11, "#FF0000"],
            [10, 10, "#FF9900"],
            [10, 12, "#FF9900"],
            [10, 14, "#D9D9D9"],
            [11, 14, "#D9D9D9"],
            [11, 13, "#D9D9D9"],
            [12, 12, "#D9D9D9"],
            [13, 13, "#D9D9D9"],
            [5, 16, "#D9D9D9"],
            [4, 16, "#D9D9D9"],
            [3, 16, "#D9D9D9"],
            [2, 16, "#D9D9D9"],
            [2, 13, "#D9D9D9"],
            [2, 15, "#D9D9D9"],
            [3, 15, "#D9D9D9"],
            [4, 15, "#D9D9D9"],
            [4, 14, "#D9D9D9"],
            [3, 14, "#D9D9D9"],
            [2, 14, "#D9D9D9"],
            [5, 14, "#D9D9D9"],
            [3, 13, "#D9D9D9"],
            [2, 12, "#D9D9D9"],
            [3, 12, "#D9D9D9"],
            [4, 12, "#D9D9D9"],
            [3, 11, "#D9D9D9"],
            [2, 11, "#D9D9D9"],
            [4, 11, "#D9D9D9"],
            [3, 10, "#D9D9D9"],
            [2, 10, "#D9D9D9"],
            [3, 9, "#D9D9D9"],
            [2, 9, "#D9D9D9"],
            [4, 9, "#D9D9D9"],
            [2, 8, "#D9D9D9"],
            [1, 8, "#D9D9D9"],
            [3, 8, "#D9D9D9"],
            [1, 7, "#D9D9D9"],
            [2, 7, "#D9D9D9"],
            [3, 7, "#D9D9D9"],
            [6, 7, "#D9D9D9"],
            [5, 6, "#D9D9D9"],
            [3, 6, "#D9D9D9"],
            [2, 6, "#D9D9D9"],
            [1, 6, "#D9D9D9"],
            [1, 5, "#D9D9D9"],
            [2, 5, "#D9D9D9"],
            [3, 5, "#D9D9D9"],
            [1, 4, "#D9D9D9"],
            [3, 4, "#D9D9D9"],
            [2, 4, "#D9D9D9"],
            [1, 3, "#D9D9D9"],
            [2, 3, "#D9D9D9"],
            [3, 3, "#D9D9D9"],
            [1, 2, "#D9D9D9"],
            [2, 2, "#D9D9D9"],
            [3, 2, "#D9D9D9"],
            [4, 2, "#D9D9D9"],
            [5, 2, "#D9D9D9"],
            [6, 2, "#D9D9D9"],
            [6, 3, "#D9D9D9"],
            [6, 4, "#D9D9D9"],
            [5, 4, "#D9D9D9"],
            [7, 5, "#D9D9D9"],
            [8, 4, "#D9D9D9"],
            [10, 6, "#D9D9D9"],
            [10, 5, "#D9D9D9"],
            [10, 4, "#D9D9D9"],
            [10, 2, "#D9D9D9"],
            [10, 3, "#D9D9D9"],
            [9, 2, "#D9D9D9"],
            [8, 2, "#D9D9D9"],
            [1, 1, "#D9D9D9"],
            [2, 1, "#D9D9D9"],
            [6, 1, "#D9D9D9"],
            [4, 1, "#D9D9D9"],
            [3, 1, "#D9D9D9"],
            [5, 1, "#D9D9D9"],
            [7, 1, "#D9D9D9"],
            [8, 1, "#D9D9D9"],
            [9, 1, "#D9D9D9"],
            [10, 1, "#D9D9D9"],
            [11, 1, "#D9D9D9"],
            [13, 1, "#D9D9D9"],
            [12, 1, "#D9D9D9"],
            [14, 1, "#D9D9D9"],
            [15, 1, "#D9D9D9"],
            [17, 1, "#D9D9D9"],
            [16, 1, "#D9D9D9"],
            [15, 2, "#D9D9D9"],
            [16, 2, "#D9D9D9"],
            [14, 2, "#D9D9D9"],
            [13, 2, "#D9D9D9"],
            [12, 2, "#D9D9D9"],
            [11, 2, "#D9D9D9"],
            [11, 3, "#D9D9D9"],
            [13, 3, "#D9D9D9"],
            [12, 3, "#D9D9D9"],
            [14, 3, "#D9D9D9"],
            [15, 3, "#D9D9D9"],
            [14, 4, "#D9D9D9"],
            [13, 4, "#D9D9D9"],
            [12, 4, "#D9D9D9"],
            [11, 4, "#D9D9D9"],
            [11, 5, "#D9D9D9"],
            [12, 5, "#D9D9D9"],
            [13, 5, "#D9D9D9"],
            [12, 6, "#D9D9D9"],
        ],
    },
    {
        date: 1516989157336,
        row: 18,
        col: 18,
        squares: [
            [2, 1, "#FF0000"],
            [1, 2, "#FF0000"],
            [2, 3, "#FF0000"],
            [1, 4, "#FF0000"],
            [2, 5, "#FF0000"],
            [1, 6, "#FF0000"],
            [2, 7, "#FF0000"],
            [1, 5, "#FFFF00"],
            [2, 4, "#FFFF00"],
            [1, 3, "#FFFF00"],
            [2, 2, "#FFFF00"],
            [1, 1, "#FFFF00"],
            [2, 6, "#FFFF00"],
            [1, 7, "#FFFF00"],
            [2, 8, "#FFFF00"],
            [1, 9, "#FFFF00"],
            [2, 10, "#FFFF00"],
            [1, 11, "#FFFF00"],
            [2, 12, "#FFFF00"],
            [1, 13, "#FFFF00"],
            [2, 14, "#FFFF00"],
            [1, 15, "#FFFF00"],
            [2, 16, "#FFFF00"],
            [1, 17, "#FFFF00"],
            [2, 18, "#FFFF00"],
            [3, 17, "#FFFF00"],
            [3, 15, "#FFFF00"],
            [3, 13, "#FFFF00"],
            [3, 11, "#FFFF00"],
            [3, 9, "#FFFF00"],
            [4, 10, "#FFFF00"],
            [4, 12, "#FFFF00"],
            [4, 14, "#FFFF00"],
            [4, 16, "#FFFF00"],
            [4, 18, "#FFFF00"],
            [4, 4, "#FFFF00"],
            [3, 5, "#FFFF00"],
            [4, 6, "#FFFF00"],
            [3, 7, "#FFFF00"],
            [4, 8, "#FFFF00"],
            [3, 1, "#FFFF00"],
            [4, 2, "#FFFF00"],
            [3, 3, "#FFFF00"],
            [5, 1, "#FFFF00"],
            [5, 3, "#FFFF00"],
            [5, 5, "#FFFF00"],
            [5, 7, "#FFFF00"],
            [5, 9, "#FFFF00"],
            [5, 11, "#FFFF00"],
            [5, 13, "#FFFF00"],
            [5, 15, "#FFFF00"],
            [5, 17, "#FFFF00"],
            [1, 8, "#FF0000"],
            [2, 9, "#FF0000"],
            [1, 10, "#FF0000"],
            [1, 12, "#FF0000"],
            [2, 11, "#FF0000"],
            [3, 10, "#FF0000"],
            [4, 9, "#FF0000"],
            [5, 8, "#FF0000"],
            [3, 8, "#FF0000"],
            [4, 7, "#FF0000"],
            [5, 6, "#FF0000"],
            [4, 5, "#FF0000"],
            [5, 4, "#FF0000"],
            [4, 3, "#FF0000"],
            [5, 2, "#FF0000"],
            [4, 1, "#FF0000"],
            [3, 2, "#FF0000"],
            [3, 4, "#FF0000"],
            [3, 6, "#FF0000"],
            [4, 11, "#FF0000"],
            [5, 10, "#FF0000"],
            [1, 14, "#FF0000"],
            [2, 15, "#FF0000"],
            [1, 16, "#FF0000"],
            [2, 17, "#FF0000"],
            [1, 18, "#FF0000"],
            [3, 16, "#FF0000"],
            [4, 15, "#FF0000"],
            [5, 14, "#FF0000"],
            [4, 13, "#FF0000"],
            [3, 14, "#FF0000"],
            [2, 13, "#FF0000"],
            [3, 12, "#FF0000"],
            [5, 12, "#FF0000"],
            [5, 16, "#FF0000"],
            [5, 18, "#FF0000"],
            [4, 17, "#FF0000"],
            [3, 18, "#FF0000"],
            [6, 8, "#FFFF00"],
            [7, 9, "#FFFF00"],
            [8, 10, "#FFFF00"],
            [9, 11, "#FFFF00"],
            [10, 12, "#FFFF00"],
            [9, 13, "#FFFF00"],
            [8, 14, "#FFFF00"],
            [7, 15, "#FFFF00"],
            [6, 16, "#FFFF00"],
            [6, 14, "#FFFF00"],
            [6, 12, "#FFFF00"],
            [6, 10, "#FFFF00"],
            [7, 11, "#FFFF00"],
            [7, 13, "#FFFF00"],
            [8, 12, "#FFFF00"],
            [6, 2, "#FFFF00"],
            [7, 3, "#FFFF00"],
            [8, 4, "#FFFF00"],
            [9, 5, "#FFFF00"],
            [10, 6, "#FFFF00"],
            [11, 7, "#FFFF00"],
            [12, 8, "#FFFF00"],
            [6, 4, "#FFFF00"],
            [6, 6, "#FFFF00"],
            [7, 7, "#FFFF00"],
            [8, 8, "#FFFF00"],
            [9, 9, "#FFFF00"],
            [10, 10, "#FFFF00"],
            [11, 11, "#FFFF00"],
            [12, 10, "#FFFF00"],
            [13, 9, "#FFFF00"],
            [11, 9, "#FFFF00"],
            [10, 8, "#FFFF00"],
            [9, 7, "#FFFF00"],
            [8, 6, "#FFFF00"],
            [7, 5, "#FFFF00"],
            [6, 13, "#FF0000"],
            [7, 12, "#FF0000"],
            [8, 11, "#FF0000"],
            [9, 10, "#FF0000"],
            [10, 9, "#FF0000"],
            [11, 8, "#FF0000"],
            [10, 7, "#FF0000"],
            [9, 6, "#FF0000"],
            [8, 5, "#FF0000"],
            [7, 6, "#FF0000"],
            [6, 7, "#FF0000"],
            [7, 8, "#FF0000"],
            [8, 7, "#FF0000"],
            [9, 8, "#FF0000"],
            [8, 9, "#FF0000"],
            [6, 9, "#FF0000"],
            [7, 10, "#FF0000"],
            [6, 11, "#FF0000"],
            [6, 15, "#FF0000"],
            [7, 14, "#FF0000"],
            [8, 13, "#FF0000"],
            [9, 12, "#FF0000"],
            [10, 11, "#FF0000"],
            [11, 10, "#FF0000"],
            [12, 9, "#FF0000"],
            [6, 5, "#FF0000"],
            [7, 4, "#FF0000"],
            [6, 3, "#FF0000"],
            [6, 18, "#FFFF00"],
            [7, 17, "#FFFF00"],
            [8, 16, "#FFFF00"],
            [10, 15, "#FF0000"],
            [9, 15, "#FFFF00"],
            [10, 14, "#FFFF00"],
            [11, 13, "#FFFF00"],
            [12, 12, "#FFFF00"],
            [13, 11, "#FFFF00"],
            [14, 10, "#FFFF00"],
            [15, 9, "#FFFF00"],
            [16, 8, "#FFFF00"],
            [15, 7, "#FFFF00"],
            [14, 6, "#FFFF00"],
            [13, 5, "#FFFF00"],
            [12, 4, "#FFFF00"],
            [11, 3, "#FFFF00"],
            [10, 2, "#FFFF00"],
            [9, 1, "#FFFF00"],
            [8, 2, "#FFFF00"],
            [7, 1, "#FFFF00"],
            [9, 3, "#FFFF00"],
            [10, 4, "#FFFF00"],
            [11, 5, "#FFFF00"],
            [11, 6, "#FF0000"],
            [12, 6, "#FFFF00"],
            [13, 7, "#FFFF00"],
            [14, 8, "#FFFF00"],
            [6, 1, "#FF0000"],
            [8, 1, "#FF0000"],
            [7, 2, "#FF0000"],
            [9, 2, "#FF0000"],
            [8, 3, "#FF0000"],
            [9, 4, "#FF0000"],
            [10, 5, "#FF0000"],
            [12, 7, "#FF0000"],
            [13, 6, "#FF0000"],
            [12, 5, "#FF0000"],
            [11, 4, "#FF0000"],
            [10, 3, "#FF0000"],
            [8, 15, "#FF0000"],
            [9, 14, "#FF0000"],
            [10, 13, "#FF0000"],
            [11, 12, "#FF0000"],
            [12, 11, "#FF0000"],
            [13, 10, "#FF0000"],
            [14, 9, "#FF0000"],
            [13, 8, "#FF0000"],
            [14, 7, "#FF0000"],
            [15, 8, "#FF0000"],
            [6, 17, "#FF0000"],
            [7, 16, "#FF0000"],
            [7, 18, "#FF0000"],
            [8, 17, "#FF0000"],
            [9, 16, "#FF0000"],
            [12, 13, "#FF0000"],
            [11, 14, "#FF0000"],
            [13, 12, "#FF0000"],
            [14, 11, "#FF0000"],
            [15, 10, "#FF0000"],
            [16, 9, "#FF0000"],
            [17, 7, "#FFFF00"],
            [16, 7, "#FF0000"],
            [15, 6, "#FF0000"],
            [14, 5, "#FF0000"],
            [13, 4, "#FF0000"],
            [12, 3, "#FF0000"],
            [11, 2, "#FF0000"],
            [10, 1, "#FF0000"],
            [17, 8, "#FF0000"],
            [18, 7, "#FF0000"],
            [18, 9, "#FF0000"],
            [17, 10, "#FF0000"],
            [16, 11, "#FF0000"],
            [15, 13, "#FFFF00"],
            [15, 12, "#FF0000"],
            [14, 13, "#FF0000"],
            [13, 14, "#FF0000"],
            [12, 15, "#FF0000"],
            [11, 16, "#FF0000"],
            [10, 17, "#FF0000"],
            [9, 17, "#FFFF00"],
            [9, 18, "#FF0000"],
            [8, 18, "#FFFF00"],
            [10, 16, "#FFFF00"],
            [11, 15, "#FFFF00"],
            [12, 14, "#FFFF00"],
            [13, 13, "#FFFF00"],
            [14, 12, "#FFFF00"],
            [15, 11, "#FFFF00"],
            [16, 10, "#FFFF00"],
            [17, 9, "#FFFF00"],
            [17, 6, "#FF0000"],
            [16, 6, "#FFFF00"],
            [15, 5, "#FFFF00"],
            [14, 4, "#FFFF00"],
            [13, 3, "#FFFF00"],
            [12, 2, "#FFFF00"],
            [11, 1, "#FFFF00"],
            [13, 1, "#FFFF00"],
            [14, 2, "#FFFF00"],
            [15, 3, "#FFFF00"],
            [16, 4, "#FFFF00"],
            [17, 5, "#FFFF00"],
            [18, 6, "#FFFF00"],
            [18, 8, "#FFFF00"],
            [10, 18, "#FFFF00"],
            [11, 17, "#FFFF00"],
            [12, 16, "#FFFF00"],
            [13, 15, "#FFFF00"],
            [14, 14, "#FFFF00"],
            [16, 12, "#FFFF00"],
            [17, 11, "#FFFF00"],
            [18, 10, "#FFFF00"],
            [18, 12, "#FFFF00"],
            [17, 13, "#FFFF00"],
            [15, 15, "#FFFF00"],
            [14, 16, "#FFFF00"],
            [13, 17, "#FFFF00"],
            [12, 18, "#FFFF00"],
            [16, 14, "#FFFF00"],
            [17, 15, "#FFFF00"],
            [16, 16, "#FFFF00"],
            [15, 17, "#FFFF00"],
            [14, 18, "#FFFF00"],
            [16, 18, "#FFFF00"],
            [17, 17, "#FFFF00"],
            [18, 17, "#FF0000"],
            [18, 16, "#FFFF00"],
            [18, 14, "#FFFF00"],
            [18, 18, "#FFFF00"],
            [17, 18, "#FF0000"],
            [17, 16, "#FF0000"],
            [18, 15, "#FF0000"],
            [17, 14, "#FF0000"],
            [16, 15, "#FF0000"],
            [15, 14, "#FF0000"],
            [14, 15, "#FF0000"],
            [16, 17, "#FF0000"],
            [15, 16, "#FF0000"],
            [14, 17, "#FF0000"],
            [13, 16, "#FF0000"],
            [12, 17, "#FF0000"],
            [11, 18, "#FF0000"],
            [13, 18, "#FF0000"],
            [15, 18, "#FF0000"],
            [17, 3, "#FFFF00"],
            [16, 2, "#FFFF00"],
            [15, 1, "#FFFF00"],
            [18, 4, "#FFFF00"],
            [17, 1, "#FFFF00"],
            [18, 2, "#FFFF00"],
            [14, 3, "#FF0000"],
            [15, 2, "#FF0000"],
            [16, 1, "#FF0000"],
            [18, 1, "#FF0000"],
            [17, 4, "#FF0000"],
            [18, 3, "#FF0000"],
            [18, 5, "#FF0000"],
            [16, 5, "#FF0000"],
            [15, 4, "#FF0000"],
            [16, 3, "#FF0000"],
            [14, 1, "#FF0000"],
            [13, 2, "#FF0000"],
            [12, 1, "#FF0000"],
            [17, 2, "#FF0000"],
            [18, 11, "#FF0000"],
            [17, 12, "#FF0000"],
            [16, 13, "#FF0000"],
            [18, 13, "#FF0000"],
        ],
    },
    {
        date: 1445438181081,
        row: 18,
        col: 18,
        squares: [
            [2, 2, "#000080"],
            [2, 3, "#000080"],
            [2, 4, "#000080"],
            [3, 2, "#000080"],
            [4, 2, "#000080"],
            [3, 3, "#008080"],
            [4, 4, "#008080"],
            [4, 3, "#00FFFF"],
            [5, 4, "#00FFFF"],
            [6, 5, "#00FFFF"],
            [7, 6, "#00FFFF"],
            [5, 5, "#008080"],
            [6, 6, "#008080"],
            [7, 7, "#008080"],
            [8, 8, "#008080"],
            [9, 9, "#008080"],
            [10, 10, "#008080"],
            [11, 11, "#008080"],
            [11, 10, "#00FFFF"],
            [10, 9, "#00FFFF"],
            [9, 8, "#00FFFF"],
            [8, 7, "#00FFFF"],
            [10, 11, "#00FFFF"],
            [9, 10, "#00FFFF"],
            [8, 9, "#00FFFF"],
            [7, 8, "#00FFFF"],
            [6, 7, "#00FFFF"],
            [5, 6, "#00FFFF"],
            [4, 5, "#00FFFF"],
            [3, 4, "#00FFFF"],
            [5, 3, "#000080"],
            [6, 4, "#000080"],
            [7, 5, "#000080"],
            [8, 6, "#000080"],
            [9, 7, "#000080"],
            [10, 8, "#000080"],
            [11, 9, "#000080"],
            [12, 10, "#000080"],
            [12, 11, "#000080"],
            [11, 12, "#000080"],
            [10, 12, "#000080"],
            [9, 11, "#000080"],
            [8, 10, "#000080"],
            [7, 9, "#000080"],
            [6, 8, "#000080"],
            [5, 7, "#000080"],
            [4, 6, "#000080"],
            [3, 5, "#000080"],
            [9, 13, "#000080"],
            [8, 14, "#000080"],
            [8, 15, "#000080"],
            [9, 15, "#000080"],
            [10, 14, "#000080"],
            [11, 14, "#000080"],
            [12, 13, "#000080"],
            [13, 12, "#000080"],
            [13, 9, "#000080"],
            [14, 8, "#000080"],
            [15, 8, "#000080"],
            [15, 9, "#000080"],
            [14, 10, "#000080"],
            [14, 11, "#000080"],
            [14, 9, "#008080"],
            [13, 10, "#008080"],
            [9, 14, "#008080"],
            [10, 13, "#008080"],
            [13, 11, "#00FFFF"],
            [12, 12, "#FFFF00"],
            [11, 13, "#00FFFF"],
            [13, 13, "#FF0000"],
            [14, 14, "#FF0000"],
            [14, 13, "#800080"],
            [15, 14, "#800080"],
            [13, 14, "#800080"],
            [14, 15, "#800080"],
            [15, 15, "#FF0000"],
            [16, 16, "#FFFF00"],
            [16, 15, "#000080"],
            [17, 15, "#000080"],
            [17, 16, "#000080"],
            [17, 17, "#000080"],
            [16, 17, "#000080"],
            [15, 17, "#000080"],
            [15, 16, "#000080"],
        ],
    },
];
